import { isProductMode, isPrerenderer } from '@/common/utils/common'
import { REDIRECT_MAP } from '@/common/utils/redirect/redirect-map'
import { MOBILE_WEB_HOSTNAME } from '@/common/utils/request.const'

// redirect public/index.html script 태그 안에 있던 로직 제거 후 현재 메서드로 이동
export const redirect = () => {
  const deviceType = window.uaInfo.getDevice().type
  const isIpad =
    navigator.userAgent.match(/Mac|MacIntel/) === null
      ? false
      : navigator.userAgent.match(/Mac|MacIntel/).length > 0 &&
        navigator.maxTouchPoints > 2
  const isMobileDevice =
    deviceType === 'mobile' || deviceType === 'tablet' || isIpad
  const toDomain = isMobileDevice ? 'm.wavve.com' : 'www.wavve.com'

  if (isProductMode && !isPrerenderer()) {
    const toUrl = location.href
    if (location.hostname === 'wavve.com') {
      location.replace(
        toUrl
          .replace('www.wavve.com', toDomain)
          .replace(location.protocol, 'https:'),
      )
    } else if (location.hostname === 'www.wavve.com') {
      if (location.protocol === 'http:' || isMobileDevice) {
        location.replace(
          toUrl
            .replace(location.hostname, toDomain)
            .replace(location.protocol, 'https:'),
        )
      }
    } else if (location.hostname.match(/(dev-www|qa-www)/gi)) {
      if (isMobileDevice) {
        location.replace(
          toUrl
            .replace(
              location.hostname,
              REDIRECT_MAP[location.hostname] ?? MOBILE_WEB_HOSTNAME,
            )
            .replace(location.protocol, 'https:'),
        )
      }
    }
  }
}
